export const merchantCategoriesGlobal = {
  DEV: {
    ['7DnZwZo6Bus3NwhYznmp']: {
      id: '7DnZwZo6Bus3NwhYznmp',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fbulb.png?alt=media&token=88af8be5-ac23-4796-8594-e81dc295ed6f',
      name: 'Lighting/Electric',
      name_ar: 'كهرباء / إنارة',
    },
    ['9QO21zyKKEUekB6Ut0JK']: {
      id: '9QO21zyKKEUekB6Ut0JK',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fpainting.png?alt=media&token=d8aac8a7-e00f-4b58-b1b2-f924019e1677',
      name: 'Painters',
      name_ar: 'أعمال الدهان',
    },
    ['Rmlp0S0fbo2TGzCbLpgO']: {
      id: 'Rmlp0S0fbo2TGzCbLpgO',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fac.png?alt=media&token=bf1a1a97-e4b8-4429-b2cb-c3fa6b9635a4',
      name: 'Cooling/Heating',
      name_ar: 'تبريد/تسخين',
    },
    ['bWcYEJ6MsCnXEbnTn3wJ']: {
      id: 'bWcYEJ6MsCnXEbnTn3wJ',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fplumbing%202.png?alt=media&token=a68ffc1b-44bd-4b2a-ab1e-29ac771ea5f3',
      name: 'Plumbing',
      name_ar: 'سباكة',
    },
    ['pEoeIOdhh2Tdw5rdDvwv']: {
      id: 'pEoeIOdhh2Tdw5rdDvwv',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fcarpenter.png?alt=media&token=96952781-cf3c-410c-b186-b53880d8426c',
      name: 'Carpeting/Decor',
      name_ar: 'نجارة/ديكور',
    },
    ['Zcz03pnTUU8YXsFiJrul']: {
      id: 'Zcz03pnTUU8YXsFiJrul',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fcctv.png?alt=media&token=bef60818-b447-46aa-bd5d-71101c59396a',
      name: 'CCTV',
      name_ar: 'أنظمة المراقبة',
    },
  },
  PROD: {
    ['yKR9BQaFceMYsEVkRqbb']: {
      id: 'yKR9BQaFceMYsEVkRqbb',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fbulb.png?alt=media&token=88af8be5-ac23-4796-8594-e81dc295ed6f',
      name: 'Lighting/Electric',
      name_ar: 'كهرباء / إنارة',
    },
    ['u36YPjb4NrkzTTVRlSKz']: {
      id: 'u36YPjb4NrkzTTVRlSKz',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fpainting.png?alt=media&token=d8aac8a7-e00f-4b58-b1b2-f924019e1677',
      name: 'Painters',
      name_ar: 'أعمال الدهان',
    },
    ['dYK3pXqYTukh8o8syIHg']: {
      id: 'dYK3pXqYTukh8o8syIHg',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fac.png?alt=media&token=bf1a1a97-e4b8-4429-b2cb-c3fa6b9635a4',
      name: 'Cooling/Heating',
      name_ar: 'تبريد/تسخين',
    },

    ['TuO6SKPJSGFZXIT0KTQN']: {
      id: 'TuO6SKPJSGFZXIT0KTQN',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fplumbing%202.png?alt=media&token=a68ffc1b-44bd-4b2a-ab1e-29ac771ea5f3',
      name: 'Plumbing',
      name_ar: 'سباكة',
    },
    ['irpaGwLHTl8Qza4o2jLp']: {
      id: 'irpaGwLHTl8Qza4o2jLp',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fcarpenter.png?alt=media&token=96952781-cf3c-410c-b186-b53880d8426c',
      name: 'Carpeting/Decor',
      name_ar: 'نجارة/ديكور',
    },
    ['gVooiWctlj978pM83zjO']: {
      id: 'gVooiWctlj978pM83zjO',
      image:
        'https://firebasestorage.googleapis.com/v0/b/reno-tech.appspot.com/o/images%2FmerchantCategories%2Fcctv.png?alt=media&token=bef60818-b447-46aa-bd5d-71101c59396a',
      name: 'CCTV',
      name_ar: 'أنظمة المراقبة',
    },
  },
};
